import script from "./StudyFormClinician.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyFormClinician.vue?vue&type=script&setup=true&lang=js"

import "./StudyFormClinician.vue?vue&type=style&index=0&id=256876d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256876d8"]])

export default __exports__